
import Vue from "vue";
// var loadingInstance = null

import store from '@/store'

import { getFileInfo, host } from '@/api/api.js'
function utils() {
    Vue.prototype.rootScrollY = 0
    Vue.prototype.rootScrollToTop = function(){
        window.scrollTo(0,0);
      }
    Vue.prototype.bxDeepClone=function(obj) {
        if (obj == null) return null;
        let newObj = obj instanceof Array ? [] : {};
        for (var i in obj) {
            newObj[i] = typeof obj[i] === "object" ? this.bxDeepClone(obj[i]) : obj[i];
        }
        return newObj;
    }
    Vue.prototype.getFileUrls = async function(fileNo){
        let urls = []
        await getFileInfo(fileNo).then(res =>{ 
            // console.log('getFileInfo',res)
            if(Array.isArray(res.data)){
                urls = res.data.map(item => item)
            }
        })

        return urls
        
    }
    Vue.prototype.getNavBarData = function(no){
        let navs = store.getters.getNavs
        navs = Vue.prototype.getTree(navs,'key','parent_no',no)
        if(navs.length == 1){
            navs = navs[0]
        }
        return navs
    }
    Vue.prototype.getTree = function(arr,key,pkey,keyValue){
        let list = []
        function getChildren(item,arr,ckey,cpkey){
            if(item){
                let children = arr.filter(child => child[cpkey] == item[ckey])
                if(children.length > 0){
                    for(let c of children){
                        c = getChildren(c,arr,ckey,cpkey)
                    }
                    
                }else{

                }
                item['children'] = children.map(item => item)
            }
            return item
        }
        if(Array.isArray(arr) && key && pkey && keyValue){
             list = arr.filter(item => item[key] == keyValue)

             for(let item of list){
                item = getChildren(item,arr,key,pkey)
             }
        }

        return list
        
    }
    Vue.prototype.onSearch = function(e){
        let url = `/policy`
        // ?${e.name}=${encodeURIComponent(e.value)}
        if(e && e.length > 0){
            url = url + '?'
            for(let search of e){
                console.log(url.indexOf('?'),url.length)
                if(url.indexOf('?') == url.length - 1){
                    url = `${url}&${search.name}=${encodeURIComponent(search.value)}`
                }
                
            }
            this.$router.push({
                path:`${url}`
            })
        }else{

        }
        
        console.log(e)
    }
    Vue.prototype.reHtmlImgSrc = function (str){
        var data = [];
            str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, function (match, capture) {
                  data.push(capture);
            });
            // console.log(data)
        return data
    }
    Vue.prototype.getArrayCol = function (arr,rowAllLen){
        var col = null;
        let len = arr.length
        
        if(Array.isArray(arr)){
            col = rowAllLen % len == 0 ? rowAllLen/len :rowAllLen/ (len - 1)
        }else{
            col = 1
        }
        // console.log('当前data row colspan:',arr,col)
        return col
    }
    Vue.prototype.toHome = function (){
        console.log('to home')
        this.$router.replace({path:'/' })
    }
    // user request
    Vue.prototype.initLoginState = function (req){
        let validTo = window.sessionStorage.getItem('validTimeTo')
        let isLogin = window.sessionStorage.getItem('isLogin')
        let loginInfo = window.sessionStorage.getItem('loginInfo')
        let token = window.sessionStorage.getItem('bx_auth_ticket')
        if(isLogin && loginInfo){
            store.commit('setLoginInfo',JSON.parse(loginInfo))
        }
    }

    /**
   * 将富文本字符串中的文件地址相对路径前缀替换为当前所用的服务端地址前缀
   * @param {*} val 富文本字符串
   * @returns 
   */
    Vue.prototype.recoverFileAddress4richText = (val = "") => {
    // 替换文件前缀
    const prefix = host + "/file/download";
    val = val?.replaceAll?.("$bxFileAddress$", prefix) || "";
    val = val?.replaceAll?.("<img", "<img style='max-width:100%'") || "";
    // 使用正则表达式来匹配 bx_auth_ticket 的值，并使用sessionStorage.bx_auth_ticket替换它
    const ticketStr = `bx_auth_ticket=${sessionStorage.bx_auth_ticket}`;
    val = val.replace(/(bx_auth_ticket=)[^&]+/ig, ticketStr);
    return val;
  }
    Vue.prototype.toHomePage = function(bar,rootId,queryParams){
        let self = this
        let rootPath = bar.href == '/' ? '/' : 'homePage'
        let rootKey = rootId ? rootId : bar.parent_no ? bar.parent_no : bar.key
        let activeKey = bar.key
        let activeLayout = 'list'
        if(bar.href && bar.href.indexOf('[') !== -1 && bar.href.indexOf(']') !== -1){
            activeLayout = bar.href.split(']')[0]
            activeLayout = activeLayout.replaceAll('[', '')
        }
        let path = ''
        let activeLayoutType = 'imgMixText'
        if(rootPath == '/'){
            self.$router.push({path:'/' })
            return 
        }else if(rootPath == 'homePage'){
            if(activeLayout == 'list'){
                if(bar.href && bar.href.indexOf(':') !== -1){
                    activeLayoutType = bar.href.split(':')[1]
                }
                path =  `/${rootPath}/${rootKey}/${activeKey}/${activeLayout}/${activeKey}/${activeLayoutType}`
            }else{
                // 不是 list 默认 子路由时 进行 自定义 适配
                path = `/${rootPath}/${rootKey}/${activeKey}/${activeLayout}`
                activeLayoutType = ''
                if(bar.href && bar.href.indexOf(':') !== -1){
                    activeLayoutType = bar.href.split(':')[1]
                    if(activeLayoutType){
                        path = `/${rootPath}/${rootKey}/${activeKey}/${activeLayout}/${activeLayoutType}`
                    }
                    
                }
            }
        }
        
        // 构建路由配置
        const routeConfig = queryParams && typeof queryParams === 'object' 
            ? { path: path, query: queryParams }
            : path;
        
        // 执行跳转
        self.$router.push(routeConfig,(sce => {
            console.log('跳转异常：',sce)
        }),(err => {
            console.log('跳转异常：',err)
        }))
    }
    Vue.prototype.toMemberCenter = function(){
        // let self = this
        let root = store.getters.getNavs
        root = this.getTree(root,'key','parent_no','LM20230713180007')
            if(root.length == 1){
                root = root[0]
            }
            store.commit('setActiveNav',root) 
        let path = '/homePage/LM20230713180007/LM20230718110002/user/个人'
        this.$router.push(path,(sce => {
            // self.$router.push({name:path,params:{ "no":nav.key }},(sce => {
            console.log('跳转异常：',sce)
        }),(err => {
            console.log('跳转异常：',err)
        }))
    }
    
}

export default utils;
